import { render, staticRenderFns } from "./GuideCard.vue?vue&type=template&id=4febaf89&scoped=true"
import script from "./GuideCard.vue?vue&type=script&lang=ts"
export * from "./GuideCard.vue?vue&type=script&lang=ts"
import style0 from "./GuideCard.vue?vue&type=style&index=0&id=4febaf89&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4febaf89",
  null
  
)

export default component.exports